import React from "react";
import AuthenticationButton from "../components/Authentication/AuthenticationButton.js";

const AuthNav = () => (
    <div className="navbar-nav ml-auto">
        <AuthenticationButton />
    </div>
);

export default AuthNav;
